var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center p-3 px-md-4 py-md-3 text-md-left border rounded d-md-flex justify-content-between align-items-center"},[_c('div',[_c('h3',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"mb-2 mb-md-0"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }